import React, { useState, useContext, useEffect } from 'react';
import { Box, Grid, Card, CardContent, Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Alert } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import ImageUploader from './ImageUploader';
import { getAuthHeaders, getAuthHeader, getImageDisplayUrl, getUploadApiBaseUrl } from '../../utils/api';

const UpdateLog = () => {
    const { log_id } = useParams(); // Hämta loggpostens ID från URL:en
    const [userId, setUserId] = useState('');
    const [title, setTitle] = useState('');
    const [year, setYear] = useState('');
    const [departureDateTime, setDepartureDateTime] = useState('');
    const [arrivalDateTime, setArrivalDateTime] = useState('');
    const [windDirection, setWindDirection] = useState('');
    const [windSpeed, setWindSpeed] = useState('');
    const [distance, setDistance] = useState('');
    const [position, setPosition] = useState('');
    const [description, setDescription] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [images, setImages] = useState([]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [closeWithoutSaveOpen, setCloseWithoutSaveOpen] = useState(false);
    const [uploadedImages, setUploadedImages] = useState([]);
    const { currentUser } = useAuth();
    const [showLoginMessage, setShowLoginMessage] = useState(false); // Statiskt tillstånd för att visa eller dölja meddelandet
    const [imagesToRemove, setImagesToRemove] = useState([]);

    useEffect(() => {
        if (currentUser === null) {
            navigate('/info');
        }
    }, [currentUser, navigate]);

    useEffect(() => {
        // Skapa en ny abort controller
        const abortController = new AbortController();
    
        // Hämta loggpostens data när komponenten laddas
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/showlog/${log_id}`, { 
            signal: abortController.signal,
            headers: getAuthHeaders()
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // Sätt state med data från servern, använd tom sträng som fallback för undefined/null
                setUserId(data.userId || '');
                setTitle(data.title || '');
                setYear(data.year || '');
                setDepartureDateTime(data.departureDateTime ? moment(data.departureDateTime).format('YYYY-MM-DDTHH:mm') : '');
                setArrivalDateTime(data.arrivalDateTime ? moment(data.arrivalDateTime).format('YYYY-MM-DDTHH:mm') : '');
                setWindDirection(data.windDirection || '');
                setWindSpeed(data.windSpeed || '');
                setDistance(data.distance || '');
                setPosition(data.position || '');
                setDescription(data.description || '');
                // Hantera bilder - kan vara array, sträng, null eller undefined
                let imagesArray = data.images || [];
                if (typeof imagesArray === 'string') {
                  try {
                    imagesArray = JSON.parse(imagesArray);
                  } catch (e) {
                    imagesArray = [];
                  }
                }
                if (!Array.isArray(imagesArray)) {
                  imagesArray = [];
                }
                setImages(imagesArray);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted');
                } else {
                    console.error('Error:', error);
                }
            });
    
        // Avbryt fetch-anropet när komponenten avmonteras
        return () => {
            abortController.abort();
        };
    }, [log_id]); // Kör useEffect när `id` ändras

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseWithoutSaveRequest = () => {
        setCloseWithoutSaveOpen(true);
    };

    const handleCloseWithoutSaveDialogClose = () => {
        setCloseWithoutSaveOpen(false);
    };

    const handleCloseWithoutSaveConfirm = () => {
        setCloseWithoutSaveOpen(false);
        navigate(`/showlog/${log_id}`);
    };

    const handleDelete = () => {
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/deletelog/${log_id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        })
            .then(response => response.text())
            .then(data => {
                console.log(data);
                navigate('/info'); // Navigera till startsidan efter en lyckad radering
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        handleClose();
    };

    const handleRemoveExistingImage = (event, indexToRemove) => {
        event.preventDefault();
        const imageToRemove = images[indexToRemove];
        setImagesToRemove(prev => [...prev, imageToRemove]);
        setImages(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setShowLoginMessage(false);
    const formData = new FormData();
    selectedFiles.forEach((file, index) => {
      formData.append(`file${index}`, file);
    });
    formData.append('accountId', userId);
    formData.append('type', 'triplog');

    let newUploadedUrls = [];
    if (selectedFiles.length > 0) {
      const uploadResponse = await fetch(`${getUploadApiBaseUrl()}/api/uploads`, {
        method: 'POST',
        headers: getAuthHeader() ? { Authorization: getAuthHeader() } : {},
        body: formData
      });
      if (!uploadResponse.ok) {
        const errData = await uploadResponse.json().catch(() => ({}));
        alert(errData.message || 'Kunde inte ladda upp bilder.');
        return;
      }
      newUploadedUrls = await uploadResponse.json();
    }

    const updatedImages = [...images, ...newUploadedUrls];

        // Skapa ett objekt med uppdaterade data att skicka till servern
        const logData = {
            userId,
            title,
            year,
            departureDateTime,
            arrivalDateTime,
            windDirection,
            windSpeed,
            distance,
            position,
            description,
            images: updatedImages // Använd updatedImages här
        };

        if (logData.distance === '') {
            logData.distance = null;
          }

    imagesToRemove.forEach(urlOrPath => {
        fetch(`${getUploadApiBaseUrl()}/api/deleteimage`, {
            method: 'DELETE',
            headers: getAuthHeaders(),
            body: JSON.stringify({ url: urlOrPath })
        })
            .then(response => response.text())
            .then(data => console.log(data))
            .catch((error) => console.error('Error:', error));
    });
console.log('log_id i updatelog: ', log_id);
console.log('user_id i updatelog: ', userId);
        //skicka till servern (servern avgör behörighet, t.ex. inbjuden redaktör)
        fetch(`${process.env.REACT_APP_SERVER_URL}/api/updatelog/${log_id}`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(logData)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 403) setShowLoginMessage(true);
                    return;
                }
                return response.text();
            })
            .then(data => {
                if (data === undefined) return;
                console.log(data);
                navigate(`/showlog/${log_id}`);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };

    return (
        <Box sx={{ maxWidth: '1200px', margin: '0 auto', padding: { xs: 2, md: 4 } }}>
            <Card>
                <CardContent>
                    {showLoginMessage && (
                        <Alert severity="warning" onClose={() => setShowLoginMessage(false)}>
                            Du har inte behörighet att uppdatera denna logg.
                        </Alert>
                    )}
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ mt: 3 }}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Rubrik"
                                    value={title}
                                    onChange={(event) => setTitle(event.target.value)}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="År"
                                    value={year}
                                    onChange={(event) => setYear(event.target.value)}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Avgångstid"
                                    type="datetime-local"
                                    value={departureDateTime}
                                    onChange={(event) => setDepartureDateTime(event.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Ankomsttid"
                                    type="datetime-local"
                                    value={arrivalDateTime}
                                    onChange={(event) => setArrivalDateTime(event.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Vindriktning"
                                    value={windDirection}
                                    onChange={(event) => setWindDirection(event.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Vindstyrka (m/s)"
                                    value={windSpeed}
                                    onChange={(event) => setWindSpeed(event.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Distans (nm)"
                                    value={distance}
                                    onChange={(event) => setDistance(event.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Från – Till"
                                    value={position}
                                    onChange={(event) => setPosition(event.target.value)}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Beskrivning"
                                    value={description}
                                    multiline
                                    rows={4}
                                    onChange={(event) => setDescription(event.target.value)}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <ImageUploader onUploadSuccess={(files) => setSelectedFiles(prev => [...prev, ...files])} />
                                    <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
                                        {images.map((imageUrl, index) => (
                                            <Box padding={2} key={index} width={300}>
                                                <Card sx={{ padding: 1, position: 'relative' }}>
                                                    <CardContent>
                                                        <button onClick={(event) => handleRemoveExistingImage(event, index)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '0',
                                                                right: '0',
                                                                background: 'red',
                                                                color: '#fff',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >X</button>

                                                        <img src={getImageDisplayUrl(imageUrl)} alt={`Image ${index}`} style={{ width: '100%' }} />
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        ))}
                                        {uploadedImages.map((imageUrl, index) => (
                                            <Box padding={2} key={index} width={300}>
                                                <Card sx={{ padding: 1 }}>
                                                    <CardContent>
                                                        <img src={getImageDisplayUrl(imageUrl)} alt="Uppladdad bild" style={{ width: '100%' }} />
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Box paddingTop={4} paddingRight={2} paddingBottom={4} paddingLeft={0}>
                            <Button variant="contained" color="primary" type="submit">Uppdatera</Button>
                            <Button 
                                variant="contained" 
                                style={{ marginLeft: '10px', backgroundColor: '#E3F2FD', color: '#1565C0' }}
                                type="button"
                                onClick={handleCloseWithoutSaveRequest}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: '#BBDEFB',
                                    },
                                }}
                            >
                                Tillbaka
                            </Button>
                        </Box>
                    </form>
                </CardContent>
            </Card >
            <Box paddingTop={4} paddingRight={2} paddingBottom={4} paddingLeft={0}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" color="warning" onClick={handleClickOpen}>Radera logg</Button>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                    >
                        <DialogTitle>Är du säker?</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Är du säker på att du vill radera denna logg? Denna åtgärd kan inte ångras.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">Avbryt</Button>
                            <Button 
                                onClick={handleDelete}
                                sx={{
                                    backgroundColor: '#E3F2FD',
                                    color: '#1565C0',
                                    '&:hover': {
                                        backgroundColor: '#BBDEFB',
                                    },
                                }}
                            >
                                Radera
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </Box>

            <Dialog
                open={closeWithoutSaveOpen}
                onClose={handleCloseWithoutSaveDialogClose}
            >
                <DialogTitle>Är du säker på att du vill stänga utan att spara?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseWithoutSaveDialogClose} color="primary">Avbryt</Button>
                    <Button
                        onClick={handleCloseWithoutSaveConfirm}
                        sx={{
                            backgroundColor: '#E3F2FD',
                            color: '#1565C0',
                            '&:hover': {
                                backgroundColor: '#BBDEFB',
                            },
                        }}
                    >
                        Stäng utan att spara
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}

export default UpdateLog;
